<payee-form-field>
  <payee-autocomplete
    [options]="clients"
    [displayWith]="clientDisplayWith"
    [formControl]="client"
    (searchChange)="setClientSubject.next($event)"
  ></payee-autocomplete>
</payee-form-field>

@if (!!ksziStatus) {
  <section id="kszi-info">
    <div
      id="client-info"
      class="top-margin-15"
    >
      <h1>Hitelező</h1>
      <div>
        <span class="data-title">Név:</span>
        <span class="data-value">{{ ksziStatus.client.name }}</span>
      </div>
      <div>
        <span class="data-title">Számlák elküldve:</span>
        <span class="data-value">
          <span>{{ ksziStatus.client.kszi_info.invoices_pending }}</span>
          <span color="grey-dark">&nbsp;/&nbsp;{{ ksziStatus.client.kszi_info.invoices_recieved }}</span>
        </span>
      </div>
      @if (ksziStatus.client.kszi_info.minutes_left > 0) {
        <div>
          <span class="data-title">Várható időtartam:</span>
          <span class="data-value">
            <span>{{ ksziStatus.client.kszi_info.minutes_left }} perc</span>
          </span>
        </div>
      }
      <div></div>
      <div>
        <span class="data-title">Név:</span>
        <span class="data-value">{{ ksziStatus.client.name }}</span>
      </div>
      @if (ksziStatus.client.kszi_enabled) {
        <div>
          <span class="data-title">Számlák küldése ettől a dátumtól:</span>
          <span class="data-value">{{ ksziStatus.client.kszi_from | date: "yyyy.MM.dd." }}</span>
        </div>
      }
      @if (!ksziStatus.client.kszi_enabled) {
        <div
          id="enable-kszi"
          class="flex"
        >
          <payee-form-field>
            <span payee-label>Számlák küldése ettől a dátumtól:</span>
            <payee-datepicker
              [max]="kszi_from_max"
              [formControl]="kszi_from"
            ></payee-datepicker>
          </payee-form-field>
          <button
            payee-button
            width="shorter"
            [disabled]="!canEnableKszi"
            (click)="enableKszi()"
          >
            Bekapcsolás
          </button>
        </div>
      }
    </div>
    <div
      id="users-info"
      class="top-margin-15"
    >
      <h1>Számlázz.hu-s Felhasználók</h1>
      <table id="users-table">
        <tr>
          <th>Név</th>
          <th>Email</th>
        </tr>
        @for (user of ksziStatus.users; track user.uuid) {
          <tr>
            <td>{{ user.name }}</td>
            <td>{{ user.email }}</td>
          </tr>
        }
      </table>
    </div>
  </section>
}
